export function assertNever(value: never): never {
  throw new Error(`Unhandled 'never' value: ${JSON.stringify(value)}`);
}
